'use strict';
class Prehome {
    init () {
        $(document).on('mouseenter', '.js-prehomeMain .cc-prehome__item', function () {
            if (Foundation.MediaQuery.atLeast('large')) {
                $(this).siblings().removeClass('cc-prehome__item--active').addClass('cc-prehome__item--notActive');
                $(this).removeClass('cc-prehome__item--notActive').addClass('cc-prehome__item--active');
            }
        });

        $(document).on('mouseleave', '.js-prehomeMain .cc-prehome__main__wrp', function () {
            $(this).find('.cc-prehome__item').removeClass('cc-prehome__item--active cc-prehome__item--notActive');
        });
    }
}

const prehome = new Prehome();
export default prehome;
